// import WebFont from 'webfontloader';

export default {
  init() { },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    window.addEventListener('load', () => {
      document.body.classList.add('js-loaded');
    })
 
    //Lettura viewport
    let vw = document.body.clientWidth * 0.01;
    let vh = window.screen.availHeight * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const is_touch_enabled = () => { 
      return ( 'ontouchstart' in window ) ||  
            ( navigator.maxTouchPoints > 0 ) ||  
            ( navigator.msMaxTouchPoints > 0 ); 
    }

    if (!is_touch_enabled()) {
      document.body.classList.toggle('is-not-touchable');
    }

    window.addEventListener('resize', () => {
      // We execute the same script as before
      vw = document.body.clientWidth * 0.01;  
      document.documentElement.style.setProperty('--vw', `${vw}px`);
      vh = window.screen.availHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    const splashCardArredamenti = document.querySelector('.js-triggerAnimationArredamenti');
    const coverArredamenti = document.querySelector('.js-CoverUpArredamenti');
    const splashContentArredamenti = document.querySelector('.js-ContentViewArredamenti');

    function mouseOverCard(cover, content) {
      cover.classList.add('slide-top');
      cover.classList.remove('slide-bottom');

      content.classList.remove('fade-out');
      content.classList.add('fade-in-bottom');
    }

    function mouseLeaveCard(cover, content) {
      cover.classList.remove('slide-top');
      cover.classList.add('slide-bottom');

      content.classList.add('fade-out');
      content.classList.remove('fade-in-bottom');
    }

    if(splashCardArredamenti){
      splashCardArredamenti.addEventListener('mouseover', () => mouseOverCard(coverArredamenti, splashContentArredamenti))
      splashCardArredamenti.addEventListener('mouseleave', () => mouseLeaveCard(coverArredamenti, splashContentArredamenti))
    }

    const splashCardPrimaCasa = document.querySelector('.js-triggerAnimationPrimaCasa');
    const coverPrimaCasa = document.querySelector('.js-CoverUpPrimaCasa');
    const splashContentPrimaCasa = document.querySelector('.js-ContentViewPrimaCasa');

    if(splashCardPrimaCasa){
      splashCardPrimaCasa.addEventListener('mouseover', () => mouseOverCard(coverPrimaCasa, splashContentPrimaCasa))
      splashCardPrimaCasa.addEventListener('mouseleave', () => mouseLeaveCard(coverPrimaCasa, splashContentPrimaCasa))
    }
     
  }, //fine finalized
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js